<template>
  <div>
    <div class="row">
          <div class="col">
            <h5 class="mb-4">
              <strong>Ajustar notificaciones</strong>
            </h5>
          </div>
        </div>
    <div class="card" v-if="userNotification.length > 0">
      <div class="card-body">
        <span v-if="userRoles.includes(consts.rolesText.PADRE_MADRE)">
          <div class="mt-1 d-flex flex-nowrap" v-for="(item, index) in userNotification" :key="index">
            <div class="mr-2 my-auto">
              <div class="custom-control custom-switch">
                <input type="checkbox"
                  :checked="!disabledNotification.includes(item.id)"
                  class="custom-control-input"
                  :id="item.id"
                  @change="addNotification(item)">
                  <label class="custom-control-label" :for="item.id"></label>
                </div>
            </div>
            <div>
              <label class="mt-2">Notificarme por correo electrónico de {{
              ((item.key === consts.SPECIFIC_PARAM.BUY || item.key === consts.SPECIFIC_PARAM.BUY_SONS) ? 'compras realizadas' : (item.key === consts.SPECIFIC_PARAM.RECHARGE || item.key === consts.SPECIFIC_PARAM.RECHARGE_SONS) ? 'recargas' :(item.key === consts.SPECIFIC_PARAM.OBSERVER || item.key === consts.SPECIFIC_PARAM.OBSERVER_SONS) ? 'anotaciones en el observador' : '') +
              ([consts.SPECIFIC_PARAM.BUY_SONS, consts.SPECIFIC_PARAM.RECHARGE_SONS, consts.SPECIFIC_PARAM.OBSERVER_SONS].includes(item.key) ? ' de mis hijo(as).' : '.')
                }}
              </label>
            </div>
          </div>
          <b-row align-v="baseline" class="mt-3">
            <b-col sm="12" md="3">
              <b-button type="submit" variant="primary" class="mb-1" @click="sendNotification()">Guardar cambios</b-button>
            </b-col>
          </b-row>
        </span>
        <span v-else>
          <div class="d-flex flex-nowrap" v-for="(item, index) in userNotification" :key="index">
            <div class="mr-2 my-auto" v-if="user.role !== consts.rolesText.PADRE_MADRE && !([consts.SPECIFIC_PARAM.OBSERVER_SONS, consts.SPECIFIC_PARAM.BUY_SONS, consts.SPECIFIC_PARAM.RECHARGE_SONS].includes(item.key))">
              <div class="custom-control custom-switch">
                <input type="checkbox"
                  :checked="!disabledNotification.includes(item.id)"
                  class="custom-control-input"
                  :id="item.id"
                  @change="addNotification(item)">
                  <label class="custom-control-label" :for="item.id"></label>
                </div>
              </div>
            <div v-if="user.role !== consts.rolesText.PADRE_MADRE && !([consts.SPECIFIC_PARAM.OBSERVER_SONS, consts.SPECIFIC_PARAM.BUY_SONS, consts.SPECIFIC_PARAM.RECHARGE_SONS, consts.SPECIFIC_PARAM.CREDIT].includes(item.key))">
              <label class="mt-2">Notificarme por correo electrónico de las {{ item.key === consts.SPECIFIC_PARAM.BUY ? 'compras realizadas' : item.key === consts.SPECIFIC_PARAM.RECHARGE ? 'recargas en linea' :item.key === consts.SPECIFIC_PARAM.OBSERVER ? 'anotaciones en el observador': '' }} </label>
            </div>
          </div>
          <b-row align-v="baseline" class="mt-3" v-if="!dataEmpty">
            <b-col sm="12" md="3">
              <b-button type="submit" variant="primary" class="mb-1" @click="sendNotification()">Guardar cambios</b-button>
            </b-col>
          </b-row>
          <empty-table v-else/>
        </span>
      </div>
    </div>
    <empty-table v-else/>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import apiClient2 from '@/services/axios/v2'
import { ToastFire } from '@/services/utilities/swal'
import { consts, showErrorMessage } from '@/services/utilities'
import emptyTable from '@/components/custom/cardEmptyList'
import store from 'store'

export default {
  name: 'userNotification',
  components: { emptyTable },
  data() {
    return {
      userNotification: [],
      disabledNotification: [],
      consts,
      formNotification: [],
      dataEmpty: false,
      userRoles: [],
    }
  },
  computed: {
    ...mapState(['user']),
  },
  methods: {
    sendNotification() {
      if (this.formNotification.length === 0) {
        ToastFire('warning', 'Se esperaban cambios')
      } else {
        apiClient2.patch(`userSpecificParam/${this.user.id}`, { sentParams: this.formNotification }).then(response => {
          ToastFire('success', 'Parámetro actualizado con éxito')
        }).catch(error => {
          ToastFire('warning', showErrorMessage(error))
        })
      }
    },
    addNotification(item) {
      const indexDisabled = this.disabledNotification.indexOf(item.id)
      if (indexDisabled >= 0) {
        this.disabledNotification.splice(indexDisabled, 1)
        let notAdd = true
        this.formNotification.forEach((element) => {
          if (element.idProfileParam === item.id) {
            element.active = true
            notAdd = false
          }
        })
        if (notAdd) {
          this.formNotification.push({
            ...(item.iduserSpecificParam && { id: item.iduserSpecificParam }),
            idSpecificParam: item.id,
            active: true,
          })
        }
      } else {
        this.disabledNotification.push(item.id)
        let notAdd = true
        this.formNotification.forEach((element) => {
          if (element.idProfileParam === item.id) {
            element.active = false
            notAdd = false
          }
        })
        if (notAdd) {
          this.formNotification.push({
            ...(item.iduserSpecificParam && { id: item.iduserSpecificParam }),
            idSpecificParam: item.id,
            active: false,
          })
        }
      }
    },
  },
  created() {
    this.userRoles = JSON.parse(store.get('userData')).roles
    apiClient2.get('userSpecificParam').then(response => {
      const data = response.data.data.length > 0 ? response.data.data.filter((item) => consts.SPECIFIC_PARAM.CREDIT !== item.key) : []
      if (data.length > 0) {
        for (const param of data) {
          this.userNotification.push({
            id: param.id,
            key: param.key,
            ...((param.userParam.length > 0 && param.userParam[0].userSpecificParam.id) && { iduserSpecificParam: param.userParam[0].userSpecificParam.id }),
          })
          for (const userParam of param.userParam) {
            if (userParam.userSpecificParam && userParam.userSpecificParam.active !== true) {
              this.disabledNotification.push(param.id)
            }
          }
        }
      } else {
        this.dataEmpty = true
      }
    })
  },
}
</script>

<style scoped>
</style>
